import Header from 'component/layout/header/Header';
import TableComponent from 'component/molecules/Table/TableComponent';
import React, { useState } from 'react';
import * as tableHeader from './factory/variablesHeader';
import { variableManagement } from 'hooks/endpoints';
import NewVariable from './factory/newVariable/NewVariable';
import styles from './VariableManagement.module.scss';
import SettingsHeader from '../layout/settingsLayout/settingsHeader/SettingsHeader';
const VariableManagement = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [item, setItem] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const handleAdd = () => {
    setItem(null);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setItem(null);
  };

  const handleEdit = (item) => {
    setIsModalOpen(true);
    setItem(item);
  };
  const filterButtons = [
    {
      buttonType: 'button',
      type: 'plus',
      label: 'New Variable',
      func: handleAdd,
    },
  ];

  const renderIsDefault = ({ header, item }) => {
    return header?.hasDefault && item?.isDefault ? (
      <div className={styles.default}>
        <p> Default</p>
      </div>
    ) : null;
  };
  return (
    <>
      <SettingsHeader title="Variables" />
      <TableComponent
        rowKey="variableId"
        headerData={tableHeader.headerData}
        api={{
          get: {
            url: variableManagement.get,
            queryKey: 'variableManagement',
          },
          delete: {
            url: variableManagement.delete,
          },
        }}
        renderAdditionalComponent={renderIsDefault}
        actions={{
          hasEdit: {
            func: handleEdit,
          },
        }}
        filterButtons={filterButtons}
        isRefetch={refetch}
      />
      <NewVariable
        isOpen={isModalOpen}
        onClose={handleClose}
        item={item}
        setRefetch={setRefetch}
      />
    </>
  );
};

export default VariableManagement;
